/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var EmptyPeopleIcon = createIcon("EmptyPeopleIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "120",
    height: "120",
    viewBox: "0 0 120 120",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M60 120c33.137 0 60-26.863 60-60S93.137 0 60 0 0 26.863 0 60s26.863 60 60 60Z",
    fill: "#CFCEFD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".35",
    d: "M34.081 66.385c-3.744 0-6.783-3.016-6.783-6.74s3.039-6.74 6.784-6.74c3.744 0 6.783 3.016 6.783 6.74s-3.039 6.74-6.784 6.74Zm37.68 12.208c-3.47 2.41-9.808 3.912-17.013 3.912-7.205 0-13.541-1.503-17.01-3.913a32.57 32.57 0 01-3.435.178C26.994 78.77 21 76.458 21 73.025c0-3.745 6.73-8.175 13.308-8.175 2.338 0 4.694.56 6.76 1.448 2.621-1.654 5.86-2.977 9.265-3.622-3.403-1.538-5.77-4.944-5.77-8.901 0-5.4 4.409-9.775 9.843-9.775 5.433 0 9.842 4.375 9.842 9.775 0 3.88-2.277 7.232-5.575 8.81 3.59.604 7.021 1.973 9.77 3.709a18.37 18.37 0 012.883-.964 6.724 6.724 0 01-3.138-5.685c0-3.724 3.038-6.74 6.783-6.74 3.745 0 6.784 3.016 6.784 6.74 0 2.34-1.2 4.4-3.02 5.609 5.25 1.175 9.766 4.703 9.766 7.771 0 3.433-5.998 5.745-13.308 5.745-1.185 0-2.336-.06-3.432-.177Z",
    fill: "#A5AEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.333 59.635c3.195 0 5.784-2.57 5.784-5.74 0-3.17-2.59-5.74-5.784-5.74s-5.783 2.57-5.783 5.74c0 3.17 2.59 5.74 5.783 5.74Zm12.53 7.64c0 2.62-5.511 4.745-12.308 4.745-6.796 0-12.303-2.125-12.303-4.745S33.764 60.1 40.56 60.1c6.797 0 12.303 4.555 12.303 7.175Zm28.36-7.64c3.195 0 5.784-2.57 5.784-5.74 0-3.17-2.59-5.74-5.784-5.74s-5.784 2.57-5.784 5.74c0 3.17 2.59 5.74 5.784 5.74Zm12.53 7.64c0 2.62-5.512 4.745-12.308 4.745s-12.308-2.125-12.308-4.745S74.648 60.1 81.445 60.1c6.796 0 12.308 4.555 12.308 7.175ZM60.657 56.8c4.884 0 8.842-3.929 8.842-8.775s-3.958-8.775-8.842-8.775c-4.883 0-8.842 3.929-8.842 8.775s3.96 8.775 8.842 8.775Z",
    fill: "#fff",
    stroke: "#0C0D0D",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.818 68.5c0 4-8.424 7.255-18.818 7.255-10.394 0-18.813-3.255-18.813-7.255s8.424-11 18.818-11c10.394 0 18.813 6.975 18.813 11Z",
    fill: "#fff",
    stroke: "#0C0D0D",
    strokeWidth: "2"
  }));
}, {
  "i18nKey": "svg.EmptyPeopleIcon"
});